"use client";

import { PropertyTypeV2 } from "commonModule/services/common";
import { decodeHTMLEntities, getLocationDisplay, getPropertyType } from "utils/property-utils";
const PropertyHeader = (props: {
  property: PropertyTypeV2;
  pmsSystem?: string;
}) => {
  const {
    property,
    pmsSystem
  } = props;
  const propertyName = decodeHTMLEntities(property?.property_name) || "";
  return <div className='mt-4 bg-white md:mt-8' data-sentry-component="PropertyHeader" data-sentry-source-file="PropertyHeader.tsx">
      {property?.state && <h1 className='line-clamp-2 text-center font-wasgaten text-[22px] font-normal leading-[1.3] tracking-[-0.22px] text-secondary500 md:text-left md:text-[32px] md:tracking-[-0.32px]'>
          {getPropertyType(property.property_type_desc)} in{" "}
          {getLocationDisplay(props.property)}
        </h1>}
      {property?.property_id ? <p className='mt-2 text-center text-base font-semibold leading-[19.2px] tracking-[-0.24px] text-secondary500 md:text-left md:text-xl md:leading-6 md:tracking-[-0.3px]'>
          Property ID: {property.NumericPropertyId}
        </p> : null}
      <div className='text-center md:text-left'>
        {/*<h2 className='mt-1 text-sm font-medium leading-[18.2px] text-Gray-700 md:mt-0 md:text-left md:text-base md:leading-[27.2px]'>
          {propertyName}
         </h2>*/}

        {/* guest, bedrooms and bathrooms details */}
        <div className='mt-2 flex flex-col flex-wrap items-center gap-y-2 text-center sm:items-center md:mt-4 md:flex-row md:text-left'>
          <div data-nosnippet className='flex flex-wrap items-center'>
            {property.max_no_guests > 0 ? <>
                <span className='pr-2 text-xs font-medium leading-3 text-Gray-700 md:text-base md:leading-7'>
                  {property.max_no_guests} guests
                </span>
              </> : null}
            {property.no_of_bedrooms > 0 && <>
                <span className='text-sm font-semibold leading-none text-[#8D91A5] md:text-base'>
                  ·
                </span>
                <span className='px-2 text-xs font-medium leading-3 text-Gray-700 md:text-base md:leading-7'>
                  {property.no_of_bedrooms}{" "}
                  {property.no_of_bedrooms > 1 ? "bedrooms" : "bedroom"}
                </span>
              </> || <>
                <span className='text-sm font-semibold leading-none text-[#8D91A5] md:text-base'>
                  ·
                </span>
                <span className='px-2 text-xs font-medium leading-3 text-Gray-700 md:text-base md:leading-7'>
                  Studio
                </span>
              </>}
            {property.no_of_bathrooms > 0 && <>
                <span className='text-sm font-semibold leading-none text-[#8D91A5] md:text-base'>
                  ·
                </span>
                <span className='px-2 text-xs font-medium leading-3 text-Gray-700 md:text-base md:leading-7'>
                  {property.no_of_bathrooms}{" "}
                  {property.no_of_bathrooms > 1 ? "bathrooms" : "bathroom"}
                </span>
              </> || null}
          </div>
        </div>
      </div>

      {pmsSystem && pmsSystem === "dhisco" && <div className='mt-1.5 items-center md:hidden'>
          <div className='mt-1.5'>
            <span className='text-xs font-medium'>
              Please note this property has a no-refund policy
            </span>
          </div>
        </div>}

      {pmsSystem && pmsSystem === "dhisco" && <span className='mt-2 hidden text-base font-medium md:block'>
          Please note this property has a no-refund policy
        </span>}
    </div>;
};
export default PropertyHeader;